<template>
    <span class="p-2">{{ time }}</span>
</template>

<script>
import moment from "moment";
export default {
    name: "clock",
    props: {
        displayDate: {
            type: Boolean,
            default: false,
        },
        displaySeconds: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            format: "",
            time: "",
        };
    },
    created() {
        this.buildFormat();
        this.getTime();
        setInterval(this.getTime, 1000);
    },
    methods: {
        buildFormat() {
            let format = "";
            if (this.displayDate) format += "DD/MM/YYYY ";
            format += "HH:mm";
            if (this.displaySeconds) format += ":ss";
            this.format = format.trim();
        },
        getTime() {
            this.time = moment().format(this.format);
        },
    },
};
</script>